import ChangelogBase from 'components/changelog-page/ChangelogBase'
import { graphql, useStaticQuery } from 'gatsby'
import { ReactElement } from 'react'
import getEnglishStrings from 'utils/getEnglishStrings'

export default function Chrome(): ReactElement {
  const queryData = useStaticQuery<Queries.ChromeChangelogQuery>(graphql`
    query ChromeChangelog {
      directus {
        application_changelog {
          strings {
            languages_code {
              code
            }
            chrome_changelog_title
            chrome_changelog_meta_description
            chrome_changelog_meta_keywords
          }
        }
      }
    }
  `)

  const changelogsStrings = getEnglishStrings(queryData.directus?.application_changelog?.strings)

  return (
    <ChangelogBase
      metaData={{
        title: changelogsStrings?.chrome_changelog_title,
        meta_description: changelogsStrings?.chrome_changelog_meta_description,
        meta_keywords: changelogsStrings?.chrome_changelog_meta_keywords,
      }}
      title={changelogsStrings?.chrome_changelog_title}
      platform="chrome"
    />
  )
}
